module.exports = __webpack_public_path__ + "img/Tplus.4fbac7f7.png";